export default __webpack_public_path__ + "static/media/user_male.49552c14.ico";